$('#appQrCode').hide();

$('#appStore').on('click', function () {
    // Change QR Code if click App Store button
    $('#iyarnQrLink').attr('src', function () {
        return $(this).attr('src').replace("iyarn-qr2.svg", "iyarn-qr.svg");
    });
    $('#appLinks').hide();
    $('#appQrCode').fadeIn(100);
});

$('#googlePlay').on('click', function () {
    // Change QR Code if click Google Play button
    $('#iyarnQrLink').attr('src', function () {
        return $(this).attr('src').replace("iyarn-qr.svg", "iyarn-qr2.svg");
    });

    $('#appLinks').hide();
    $('#appQrCode').fadeIn(100);
});

$('#appQrCodeBack').on('click', function () {
    $('#appQrCode').hide();
    $('#appLinks').show();
});

new Swiper("#ourReviewsHome", {
    slidesPerView: 1,
    pagination: {
        el: ".check-the-balance__intro .swiper-pagination",
        clickable: true,
    },
});